import React from 'react'

function WalletSummary() {
  return (
    <div>Wallet</div>
  )
}

export default WalletSummary